import { mutate } from 'swr'

import {
  patchJson,
  postJson,
  putJson,
  requestDelete,
} from '../../../data/fetchers'
import {
  DeliveryForecastItemSplit,
  PatchRequest,
  WebEdiDeliveryForecastDto,
} from '../../../data/models'

export async function requestPatchDeliveryForecastsById(
  delforId: string,
  delforDto: PatchRequest<WebEdiDeliveryForecastDto>,
): Promise<any> {
  const result = await patchJson(`/deliveryforecasts/${delforId}`, delforDto)

  // HACK: Should be called in components in order to make OptimisticUi possible
  mutate((key: string) =>
    key
      .toLowerCase()
      .startsWith(`/delivery-call-offs/${delforId}`.toLowerCase()),
  )

  return result
}

export async function requestCompleteDeliveryForecastsById(
  delforId: string,
  delforDto: PatchRequest<WebEdiDeliveryForecastDto>,
): Promise<any> {
  return await patchJson(`/deliveryforecasts/${delforId}/complete`, delforDto)
}

export async function requestPutSplitItem(
  delforId: string,
  delforItemId: string,
  id: string,
  split: DeliveryForecastItemSplit,
): Promise<any> {
  const result = await putJson(
    `/deliveryforecasts/${delforId}/items/${delforItemId}/splits/${id}`,
    split,
  )

  mutate((key: string) =>
    key
      .toLowerCase()
      .startsWith(
        `/deliveryforecasts/${delforId}/items/${delforItemId}/splits`.toLowerCase(),
      ),
  )

  return result
}

export async function requestPostSplitItem(
  delforId: string,
  delforItemId: string,
  split: DeliveryForecastItemSplit,
): Promise<any> {
  const result = await postJson(
    `/deliveryforecasts/${delforId}/items/${delforItemId}/splits`,
    split,
  )

  mutate((key: string) =>
    key
      .toLowerCase()
      .startsWith(
        `/deliveryforecasts/${delforId}/items/${delforItemId}/splits`.toLowerCase(),
      ),
  )

  return result
}

export async function requestDeleteSplitItem(
  delforId: string,
  delforItemId: string,
  splitId: string,
): Promise<any> {
  const result = await requestDelete(
    `/deliveryforecasts/${delforId}/items/${delforItemId}/splits/${splitId}`,
  )

  mutate((key: string) =>
    key
      .toLowerCase()
      .startsWith(
        `/deliveryforecasts/${delforId}/items/${delforItemId}/splits`.toLowerCase(),
      ),
  )

  return result
}
